import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class CategoryPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.categoryRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.categoryImport,
    );
    this.categoryAutocomplete = permissionChecker.match(
      Permissions.values.categoryAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.categoryCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.categoryEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.categoryDestroy,
    );
  }
}
